/** 归一化 TipTap HTML，避免 '' 与 '<p></p>' 等等价空内容反复触发同步 */
export function normalizeEditorHtml(html: string): string {
    const trimmed = (html || '').trim();
    if (!trimmed) {
        return '';
    }

    const stripped = sanitizeEditorInlineStyles(trimmed)
        .replace(/\sclass="[^"]*"/g, '')
        .replace(/\sstyle=(['"])\s*\1/g, '');

    if (
        stripped === '<p></p>'
        || stripped === '<p><br></p>'
        || stripped === '<p><br/></p>'
        || stripped === '<p><br class="ProseMirror-trailingBreak"></p>'
    ) {
        return '';
    }

    return stripped;
}

export function isSameEditorContent(a: string, b: string): boolean {
    return normalizeEditorHtml(a) === normalizeEditorHtml(b);
}

const isSafeColorValue = (value: string): boolean => {
    const color = value.trim();
    return /^#[\da-f]{3,8}$/i.test(color)
        || /^(?:rgb|hsl)a?\([\d\s.,%+-]+\)$/i.test(color);
};

/** 仅保留编辑器支持的文字颜色，移除其余行内样式。 */
export function sanitizeEditorInlineStyles(html: string): string {
    return (html || '').replace(/\sstyle=(['"])(.*?)\1/gi, (_match, _quote, styleValue) => {
        const colorDeclaration = String(styleValue)
            .split(';')
            .map(item => item.trim())
            .find(item => /^color\s*:/i.test(item));

        if (!colorDeclaration) return '';

        const color = colorDeclaration.slice(colorDeclaration.indexOf(':') + 1).trim();
        return isSafeColorValue(color) ? ` style="color: ${color}"` : '';
    });
}

/**
 * TipTap 会把用户敲出的空行序列化为 `<p></p>` 或 `<p><br></p>`。
 * App 会同时把 p 和 br 识别为换行，发布前将纯空段落转换成独立的 br，
 */
export function preserveEditorLineBreaks(html: string): string {
    return (html || '').replace(
        /<p\b[^>]*>\s*(?:<br\b[^>]*\/?\s*>)?\s*<\/p>/gi,
        '<br>',
    );
}

/**
 * 服务端内容中的 `<p><br></p>` 表示一个空段落。回填 TipTap 前需还原成
 * `<p></p>`，否则该 br 会被解析成 hardBreak，编辑器再补 trailingBreak 后
 * 会在编辑态显示成两行。
 */
export function prepareEditorHtmlForHydration(html: string): string {
    return (html || '').replace(
        /(<p\b[^>]*>)\s*<br\b[^>]*\/?\s*>\s*<\/p>/gi,
        '$1</p>',
    );
}
